import { create } from "zustand";

interface NavState {
  mobileOpen: boolean;
  openMobileNav: () => void;
  closeMobileNav: () => void;
  toggleMobileNav: () => void;
}

/**
 * In-memory navigation store for mobile drawer toggle.
 * Explicitly NOT persisted to localStorage to prevent stale mobile state
 * on desktop or across sessions.
 */
export const useNavStore = create<NavState>((set) => ({
  mobileOpen: false,
  openMobileNav: () => set({ mobileOpen: true }),
  closeMobileNav: () => set({ mobileOpen: false }),
  toggleMobileNav: () => set((state) => ({ mobileOpen: !state.mobileOpen })),
}));
